import BreakpointDisplay from './BreakpointDisplay';

export default BreakpointDisplay;



// WEBPACK FOOTER //
// ./src/components/shared/BreakpointDisplay/index.js